import React from "react";
import { MyContext } from "../context";
import { FacebookProvider, Page } from 'react-facebook';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import * as Constants from "../helper/Constants";
import _ from "lodash";
import Images from "../components/images";
import { connect } from 'react-redux';
import {  UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { Modal } from "react-bootstrap";
import UtilityFunctions from "../helper/UtilityFunctions";
import WSManager from "../helper/WSManager";
import Config from "../Config";



class FeedFooterRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        feedItem: props.feedItem,
        feedIndex: props.feedIndex,
        showQuoteModal: false,
        quoteText: '',
    };
    
  }

  openQuoteModal = () => {
    if (!WSManager.loggedIn()) {
      window.location.href = Config.RefpredictorUrl;
      return;
    }

    if (this.props.history) {
      this.props.history.push({
        pathname: '/create-post',
        state: { feedItem: this.state.feedItem, isQuote: true }
      });
      return;
    }

    this.setState({
      showQuoteModal: true,
      quoteText: '',
    });
  }

  closeQuoteModal = () => {
    this.setState({
      showQuoteModal: false,
      quoteText: '',
    });
  }

  onQuoteTextChange = (e) => {
    this.setState({
      quoteText: e.target.value
    });
  }

  submitQuotePost = () => {
    const quoteText = this.state.quoteText.trim();

    if (!quoteText) {
      return;
    }

    if (this.props.feedItemFooterProps.quotePost) {
      this.props.feedItemFooterProps.quotePost(this.state.feedItem, quoteText, this.state.feedIndex);
    }

    this.closeQuoteModal();
  }

  getPreviewText = () => {
    const content = this.state.feedItem.parent_post_content
      || this.state.feedItem.parent_activity_post_content
      || this.state.feedItem.original_post_content
      || this.state.feedItem.post_content
      || '';
    return String(content).replace(/(<\/?[^>]+(>|$)|&nbsp;)/g, " ").trim();
  }

  handleFooterAction = (action, ...args) => {
    if (!WSManager.loggedIn()) {
      window.location.href = Config.RefpredictorUrl;
      return;
    }

    if (action) {
      action(...args);
    }
  }


  render() {

    const {
      feedItem,
      feedIndex,
      showQuoteModal,
      quoteText
    } = this.state;
    
    return (
      <MyContext.Consumer>
        {context => (
          <div className = {'row-container'}>
              <div className = {'item-container'}>
                    <div className = {'items'}>
                      <i onClick = {() => this.handleFooterAction(this.props.feedItemFooterProps.likePost, feedItem, feedIndex)} className={"icon-like1 lg " + (feedItem.is_like == 0 ? '' : 'active')}></i>
                      <span>{feedItem.no_of_likes > 0 ? UtilityFunctions.abbreviateNumber(feedItem.no_of_likes) : ''}</span>
                    </div>
                    <div className = {'items'}>
                      {/* <i onClick={()=>this.props.feedItemFooterProps.reSharePost(feedItem, feedIndex)} className={`icon-repost ${Number(feedItem.is_share) !== 0 ? 'active':''}`}></i>
                      <span>{feedItem.no_of_share}</span> */}

                     <span>
                          <UncontrolledDropdown direction={'buttom'} className={'act-dropdown'}>
                              <DropdownToggle> <i className={`icon-repost ${Number(feedItem.is_share) !== 0 ? 'active':''}`}  />
                              <span>{feedItem.no_of_share > 0 ? feedItem.no_of_share : ''}</span>
                              </DropdownToggle>
                             <DropdownMenu>
                                  <DropdownItem  onClick={()=>this.handleFooterAction(this.props.feedItemFooterProps.reSharePost, feedItem, feedIndex)}><i className={'icon-repost'}  />Repost</DropdownItem >
                                  <DropdownItem onClick={this.openQuoteModal}><i className={'icon-quote'}  style={{'font-size': '13px'}}/>Quote Post</DropdownItem >
                              </DropdownMenu>
                             
                              
                          </UncontrolledDropdown>
                      </span>
                    </div>
                    <div className = {'items'}>
                      <i  onClick={()=>this.handleFooterAction(this.props.feedItemFooterProps.showComment, feedIndex)} className={`icon-comment-fill  ${Number(feedItem.is_comment) !== 0 ? 'active' : '' }`}></i>
                      <span>{feedItem.no_of_comments > 0 ? UtilityFunctions.abbreviateNumber(feedItem.no_of_comments) : ''}</span>
                    </div>
                    <div className = {'items'}>
                      <i className="icon-share-fill"></i>
                    </div>
                    <div className = {'items'}>
                      {
                        feedItem.is_bookmark == 0 ? <i className="icon-bookmaker" onClick={()=>this.handleFooterAction(this.props.feedItemFooterProps.bookMarkPost, feedItem)}></i> :
                        <i className="icon-saved active" onClick={()=>this.handleFooterAction(this.props.feedItemFooterProps.bookMarkPost, feedItem)}></i>

                      }
                      
                    </div>
              </div>
              <Modal
                show={showQuoteModal}
                onHide={this.closeQuoteModal}
                dialogClassName="quote-post-modal"
                className="center-modal"
              >
                <Modal.Body>
                  <h2>Quote Post</h2>
                  <textarea
                    className="quote-post-textarea"
                    placeholder="Add your comment..."
                    value={quoteText}
                    onChange={this.onQuoteTextChange}
                  />
                  <div className="quote-post-preview">
                    <h6>{feedItem.display_name}</h6>
                    <div>{this.getPreviewText()}</div>
                  </div>
                  <div className="modal-footer">
                    <a href
                      onClick={(e) => { e.preventDefault(); this.closeQuoteModal(); }}
                      className="btn bnt-rounded">
                      Cancel
                    </a>
                    <a href
                      onClick={(e) => { e.preventDefault(); this.submitQuotePost(); }}
                      className={"btn bnt-rounded " + (!quoteText.trim() ? 'disabled' : '')}>
                      Post
                    </a>
                  </div>
                </Modal.Body>
              </Modal>
          </div>
        )}

      </MyContext.Consumer>
    );
  }
}

export default FeedFooterRow
